import styled from 'styled-components';

export const Main = styled.main`
  max-width: 1000px;
  margin: 0 auto;
  padding: 1.2rem 1rem 3rem;
`;

export const Title = styled.h1``;

export const Subtitle = styled.p`
  color: #94a3b8;
`;

export const Banner = styled.div`
  margin: 0.75rem 0 1rem;
  padding: 0.85rem 1rem;
  border-radius: 10px;
  border: 1px solid rgba(239,68,68,.45);
  background: rgba(127,29,29,.25);
  color: #fecaca;
`;

export const ErrorText = styled.p`
  color: #fca5a5;
`;

export const Section = styled.section`
  display: grid;
  gap: 1rem;
  margin-top: ${({ $spaced }) => ($spaced ? '1.4rem' : '0')};
`;

export const SectionTitle = styled.h2`
  margin-bottom: 0;
`;

export const EmptyText = styled.p`
  color: #cbd5e1;
`;

export const Card = styled.article`
  background: ${({ $propsUpgrade }) => ($propsUpgrade ? '#082f49' : '#111827')};
  border: 1px solid ${({ $propsUpgrade }) => ($propsUpgrade ? 'rgba(34,211,238,.35)' : 'rgba(148,163,184,.2)')};
  border-radius: 12px;
  padding: 1rem;
  display: grid;
  gap: 0.4rem;
`;

export const CardTitle = styled.h3`
  margin-top: 0;
  margin-bottom: 0;
`;

export const CardStatus = styled.span`
  color: #cbd5e1;
`;

export const CardMeta = styled.span`
  color: ${({ $propsUpgrade }) => ($propsUpgrade ? '#bae6fd' : '#94a3b8')};
`;

export const CardButton = styled.button`
  justify-self: start;
  margin-top: 0.65rem;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: ${({ $danger, $propsUpgrade, $owned }) =>
    $owned ? 'rgba(30,58,96,0.6)' :
    $propsUpgrade ? '#22d3ee' :
    $danger ? '#ef4444' : '#0ea5e9'};
  color: ${({ $propsUpgrade, $owned }) =>
    $owned ? '#93c5fd' :
    $propsUpgrade ? '#00111a' : '#fff'};
  border: 1px solid ${({ $owned, $propsUpgrade }) =>
    $owned ? 'rgba(59,130,246,0.35)' :
    $propsUpgrade ? 'transparent' : 'transparent'};
  border-radius: 8px;
  padding: 0.55rem 0.9rem;
  font-size: 0.84rem;
  font-weight: 700;
  cursor: ${({ $owned }) => $owned ? 'default' : 'pointer'};

  &:disabled {
    opacity: ${({ $owned }) => $owned ? 1 : 0.8};
    cursor: ${({ $owned }) => $owned ? 'default' : 'wait'};
  }

  &:not(:disabled):hover {
    filter: brightness(1.06);
  }
`;

export const Grid = styled.div`
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
`;

// ─── Redesigned upgrade cards ─────────────────────────────────────────────
export const UpgradeCard = styled.article`
  background: ${({ $propsUpgrade, $owned }) =>
    $propsUpgrade ? 'linear-gradient(145deg, #061f30 0%, #082f49 100%)' :
    $owned ? 'linear-gradient(145deg, #0a1628 0%, #0f2040 100%)' :
    'linear-gradient(145deg, #0d1525 0%, #111827 100%)'};
  border: 1px solid ${({ $propsUpgrade, $owned }) =>
    $propsUpgrade ? 'rgba(34,211,238,.4)' :
    $owned ? 'rgba(59,130,246,.4)' :
    'rgba(148,163,184,.18)'};
  border-radius: 18px;
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  position: relative;
  overflow: hidden;
  transition: border-color 0.2s, transform 0.2s;

  &:hover {
    border-color: ${({ $propsUpgrade }) =>
      $propsUpgrade ? 'rgba(34,211,238,.7)' : 'rgba(59,130,246,.55)'};
    transform: translateY(-2px);
  }

  &::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 3px;
    background: ${({ $propsUpgrade, $owned }) =>
      $propsUpgrade ? 'linear-gradient(90deg, #22d3ee, #67e8f9)' :
      $owned ? 'linear-gradient(90deg, #3b82f6, #60a5fa)' :
      'linear-gradient(90deg, #334155, #475569)'};
    border-radius: 18px 18px 0 0;
  }
`;

export const UpgradeCardIcon = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  margin-bottom: 0.35rem;
  background: ${({ $propsUpgrade, $owned }) =>
    $propsUpgrade ? 'rgba(34,211,238,0.15)' :
    $owned ? 'rgba(59,130,246,0.15)' :
    'rgba(148,163,184,0.08)'};
  color: ${({ $propsUpgrade, $owned }) =>
    $propsUpgrade ? '#22d3ee' :
    $owned ? '#60a5fa' :
    '#94a3b8'};
`;

export const UpgradeCardLabel = styled.h3`
  font-family: 'Poppins', sans-serif;
  font-size: 0.98rem;
  font-weight: 700;
  color: #f8fafc;
  margin: 0;
`;

export const UpgradeCardPrice = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 1.55rem;
  font-weight: 900;
  color: #f8fafc;
  margin: 0.2rem 0 0.55rem;
  line-height: 1;

  span {
    font-size: 0.82rem;
    font-weight: 500;
    color: #64748b;
    margin-left: 2px;
  }
`;

export const UpgradeCardFeature = styled.div`
  display: flex;
  align-items: center;
  gap: 0.45rem;
  font-size: 0.8rem;
  color: ${({ $teal }) => $teal ? '#67e8f9' : '#94a3b8'};
  margin-bottom: 0.1rem;

  i {
    font-size: 0.68rem;
    color: ${({ $teal }) => $teal ? '#22d3ee' : '#3b82f6'};
    flex-shrink: 0;
  }
`;
